module.exports = __webpack_public_path__ + "img/奔宝采埃孚.png";